import { inject, Injectable } from '@angular/core';
import { NotificationEndpoints } from 'app/core/enums/endpoints/notification.enum';
import { ApiService } from 'app/services/api/api.service';
import { Observable } from 'rxjs';
import {
    NotificationPayload,
    UnreadCountResponse,
} from '../notifications.types';
import { NotificationEntity } from '../store/notification.models';

@Injectable({
    providedIn: 'root',
})
export class NotificationApiService {
    private _endpoints = NotificationEndpoints;
    private _apiService = inject(ApiService);

    // -----------------------------------------------------------
    // @ CRUD Methods for Notifications
    // -----------------------------------------------------------

    create(data: NotificationPayload): Observable<any> {
        return this._apiService.post(this._endpoints.create, data);
    }

    getAll(): Observable<any> {
        return this._apiService.get(this._endpoints.getAll);
    }

    getOne(id: string): Observable<any> {
        return this._apiService.get(`${this._endpoints.getOne}/${id}`);
    }

    getUnreadCount(): Observable<UnreadCountResponse> {
        return this._apiService.get(this._endpoints.unreadCount);
    }

    update(id: string, data: Partial<NotificationEntity>): Observable<any> {
        return this._apiService.update(this._endpoints.update, data, id);
    }

    markRead(id: string): Observable<any> {
        return this._apiService.update(this._endpoints.markRead, {}, id);
    }

    markAllReadByUser(): Observable<any> {
        return this._apiService.update(this._endpoints.markAllReadByUser, {});
    }

    markAllReadByReference(referenceId: string): Observable<any> {
        return this._apiService.update(
            this._endpoints.markAllReadByReference,
            {},
            referenceId
        );
    }

    delete(id: string): Observable<any> {
        return this._apiService.deleteWithParam(
            `${this._endpoints.delete}/${id}`,
            {}
        );
    }

    deleteAllByUser(): Observable<any> {
        return this._apiService.deleteWithParam(
            this._endpoints.deleteAllByUser,
            {}
        );
    }

    deleteAllByReference(referenceId: string): Observable<any> {
        return this._apiService.deleteWithParam(
            `${this._endpoints.deleteAllByReference}/${referenceId}`,
            {}
        );
    }
}
